import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CynoFormModule } from '@app/shared/cyno-form/cyno-form.module';
import { TooltipModule } from '@app/shared/tooltip/tooltip.module';
import { ClickTooltipModule } from '@app/shared/ux/click-tooltip/click-tooltip.module';
import { OutClaimNotificationModule } from 'outshared-lib';
import { ClaimNotificationDataComponent } from './claim-notification-data';
import { ClaimNotificationSectionComponent } from './claim-notification-section';
import { ClaimNotificationComponent } from './claim-notification.component';
import { ClaimNotificationContainer } from './claim-notification.container';

@NgModule({
    declarations: [
        ClaimNotificationContainer,
        ClaimNotificationComponent,
        ClaimNotificationSectionComponent,
        ClaimNotificationDataComponent,
    ],
    imports: [
        CommonModule,
        CynoFormModule,
        RouterModule,
        OutClaimNotificationModule,
        ClickTooltipModule,
        TooltipModule,
    ],
    exports: [ClaimNotificationContainer],
})
export class ClaimNotificationModule {}
